// extracted by mini-css-extract-plugin
module.exports = {"contextMenu":"styles_contextMenu__26y4r","visible":"styles_visible__HpZaD"};